import monitorpage from "./monitorpage.js";
import monitordetail from "./monitordetail.js";
import monitorchanges from "./monitorchanges.js";
import addrobot from "./addrobot.js";
import addmonitor from "./addmonitor.js";

export default {
  monitorpage,
  monitordetail,
  monitorchanges,
  addrobot,
  addmonitor,
};
